import { useMemo, useState } from 'react';
import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import { topics } from '@/mocks/topics';
import TopicCard from '@/components/feature/TopicCard';
import SectionHeading from '@/components/base/SectionHeading';

const TABS = [{ slug: 'all', name: '全部' }, ...categories.map((item) => ({ slug: item.slug, name: item.name }))];

export default function FeaturedTopics() {
  const [activeTab, setActiveTab] = useState('all');

  const list = useMemo(() => {
    const filtered = activeTab === 'all' ? topics : topics.filter((item) => item.categorySlug === activeTab);
    return [...filtered].sort((a, b) => b.heat - a.heat).slice(0, 6);
  }, [activeTab]);

  return (
    <section className="border-b border-background-200 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-shell px-4 md:px-6">
        <SectionHeading
          eyebrow="热门内容推荐"
          title="这几条正在被反复讨论"
          description="根据热度与更新频率综合排序，切换栏目即可查看对应方向的推荐内容。"
        />

        <div className="mb-8 flex gap-1 overflow-x-auto pb-1 thin-scroll" role="tablist" aria-label="栏目筛选">
          {TABS.map((tab) => (
            <button
              key={tab.slug}
              type="button"
              role="tab"
              aria-selected={activeTab === tab.slug}
              onClick={() => setActiveTab(tab.slug)}
              className={`whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition-colors ${
                activeTab === tab.slug
                  ? 'bg-primary-500 font-medium text-background-50'
                  : 'border border-background-300 text-foreground-700 hover:border-primary-300 hover:text-primary-700'
              }`}
            >
              {tab.name}
            </button>
          ))}
        </div>

        {list.length > 0 ? (
          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {list.map((topic) => (
              <TopicCard key={topic.id} topic={topic} />
            ))}
          </div>
        ) : (
          <p className="rounded-lg border border-dashed border-background-300 bg-background-100 py-12 text-center text-sm text-foreground-600">
            这个栏目暂时还没有推荐内容，换个栏目看看吧。
          </p>
        )}

        <div className="mt-10 text-center">
          <Link
            to="/topics"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-foreground-950 px-6 py-2.5 text-sm font-medium text-foreground-950 transition-colors hover:bg-foreground-950 hover:text-background-50"
          >
            打开话题库
            <i className="ri-arrow-right-line" aria-hidden="true" />
          </Link>
        </div>
      </div>
    </section>
  );
}